import React from 'react';
import ReactDOM from 'react-dom/client';
import Home from './Home';
import Login from './Login';
import Signup from './Signup';
import Payment from './Payment';
import Product from './Product';
import Settings from './Settings';
import Transaction from './Transaction';
import TransactionReceipt from './Transaction/TransactionReceipt';
import Notification from './Notification';
import TestEmail from './TestEmail';
import Loading from './Loading';


import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import ProtectedRoute from './ProtectedRoute';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; // Enables bootstrap.Modal

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <AuthProvider>
      <QueryClientProvider client={queryClient}>
    <React.StrictMode>
      <Router>
        <Routes>
        <Route path="/" element={<Loading />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/Payment" element={<Payment />} />
          <Route
            path="/TransactionReceipt"
            element={
              <ProtectedRoute>
                <TransactionReceipt />
              </ProtectedRoute>
            }
          />
          <Route path="/Product" element={<Product />} />
          <Route path="/Settings" element={<Settings />} />
          <Route
          path="/Transaction"
          element={
            <ProtectedRoute>
              <Transaction />
            </ProtectedRoute>
          }
        />
          <Route path="/Notification" element={<Notification />} />
          <Route path="/test-email" element={<TestEmail />} />

          
             <Route
          path="/home"
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        />

        </Routes>
      </Router>
    </React.StrictMode>
    </QueryClientProvider>
  </AuthProvider>
);

reportWebVitals();
